import React, { useEffect, useState } from 'react';
import axiosInstance from '../../api/axiosInstance'; // Предполагается, что axiosInstance уже настроен
import { useSelector } from 'react-redux';
import { selectUserId } from '../Login/loginSlice';
import userApi from '../../api/userApi'
import './Referals.css'


const ReferralList = () => {
    const [referrals, setReferrals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const userId = useSelector(selectUserId);

    useEffect(() => {
        const fetchReferrals = async () => {
            console.error('fetchReferrals');
            try {
                const response = await userApi.getReferals(userId);
                console.error('fetchReferrals res', response.data.referrals);
                setReferrals(response.data.referrals);
            } catch (err) {
                console.error('Error fetching referrals:', err);
                setError('Failed to load referrals');
            } finally {
                setLoading(false);
            }
        };

        if (userId) {
            fetchReferrals();
        }
    }, [userId]);

    if (loading) {
        return <div>Загрузка...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div>
            <div style={{ backgroundColor: '#fff' }}>
                <h2>Рефералы</h2>
                {referrals.length > 0 ? (
                    <ul>
                        {referrals.map((referral) => (
                            // <li key={referral.referral_id} className='refetals_text'>
                            //     {referral.referral_email || `User ID: ${referral.id}`} 
                            //     {/* (Joined: {new Date(referral.created_at).toLocaleDateString()}) */}
                            // </li>
                            <li key={referral.referral_id} className="referrals_text">
                                {referral.referral_email || `User ID: ${referral.id}`}
                                {referral.waiting === 0 && (
                                    <span className="status-badge">500</span>
                                )}
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className='refetals_text'>У вас пока нет рефералов</p>
                )}
            </div>
            <div>
                <p><strong>После регистрации по этой ссылке вашего друга и получения им первого платного ответа на ваш счет в личном кабинете будет начислено 500 баллов</strong></p>
            </div>
        </div>
    );
};

export default ReferralList;
